import type { FC } from 'react';
import type { CustomerOrderPaymentStageDto } from '@/api';

import { formatDate, formatMoney, formatNumber, toNumber } from '../lib/format';
import { PAYMENT_VARIANTS } from '../lib/paymentSchedule';

/**
 * Этапы графика оплаты заказа 1С: вариант и доля слева, сумма и срок справа.
 * Общий для карточки отгрузки («Оплата») и карточки заказа 1С.
 */
export const PaymentScheduleList: FC<{
  stages: ReadonlyArray<CustomerOrderPaymentStageDto>;
}> = ({ stages }) => (
  <div className="flex flex-col">
    {stages.map((stage, index) => (
      // Ключа у этапа нет: график приходит из 1С целиком и порядок - номер этапа.
      <div
        key={index}
        className="flex items-center gap-3 border-t border-ink-150 py-2.5 first:border-t-0 first:pt-0 last:pb-0"
      >
        <div className="min-w-0 flex-1">
          <div className="text-[13px] font-[550] text-ink-900">
            {PAYMENT_VARIANTS[stage.variant]}
          </div>
          <div className="text-xs text-ink-500 tabular-nums">
            {formatNumber(toNumber(stage.percent))}% суммы заказа
          </div>
        </div>
        <div className="text-right">
          <div className="text-[13px] font-semibold text-ink-900 tabular-nums">
            {formatMoney(toNumber(stage.amount))}
          </div>
          <div className="text-xs text-ink-500 tabular-nums">
            {stage.date ? `до ${formatDate(stage.date)}` : 'срок не задан'}
          </div>
        </div>
      </div>
    ))}
  </div>
);
